import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card mb-5 mb-xl-10",
  id: "kt_profile_details_view"
}
const _hoisted_2 = { class: "card-header cursor-pointer" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Profile Details")
], -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Edit Profile")
const _hoisted_5 = { class: "card-body p-9" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"row mb-7\"><label class=\"col-lg-4 fw-bold text-muted\">Full Name</label><div class=\"col-lg-8\"><span class=\"fw-bolder fs-6 text-dark\">Max Smith</span></div></div><div class=\"row mb-7\"><label class=\"col-lg-4 fw-bold text-muted\">Company</label><div class=\"col-lg-8 fv-row\"><span class=\"fw-bold fs-6\">Keenthemes</span></div></div><div class=\"row mb-7\"><label class=\"col-lg-4 fw-bold text-muted\"> Contact Phone <i class=\"fas fa-exclamation-circle ms-1 fs-7\" data-bs-toggle=\"tooltip\" title=\"Phone number must be active\"></i></label><div class=\"col-lg-8 d-flex align-items-center\"><span class=\"fw-bolder fs-6 me-2\">044 3276 454 935</span><span class=\"badge badge-success\">Verified</span></div></div><div class=\"row mb-7\"><label class=\"col-lg-4 fw-bold text-muted\">Company Site</label><div class=\"col-lg-8\"><a href=\"#\" class=\"fw-bold fs-6 text-dark text-hover-primary\">keenthemes.com</a></div></div><div class=\"row mb-7\"><label class=\"col-lg-4 fw-bold text-muted\"> Country <i class=\"fas fa-exclamation-circle ms-1 fs-7\" data-bs-toggle=\"tooltip\" title=\"Country of origination\"></i></label><div class=\"col-lg-8\"><span class=\"fw-bolder fs-6 text-dark\">Germany</span></div></div><div class=\"row mb-7\"><label class=\"col-lg-4 fw-bold text-muted\">Communication</label><div class=\"col-lg-8\"><span class=\"fw-bolder fs-6 text-dark\">Email, Phone</span></div></div><div class=\"row mb-10\"><label class=\"col-lg-4 fw-bold text-muted\">Allow Changes</label><div class=\"col-lg-8\"><span class=\"fw-bold fs-6\">Yes</span></div></div>", 7)
const _hoisted_13 = { class: "notice d-flex bg-light-warning rounded border-warning border border-dashed p-6" }
const _hoisted_14 = { class: "svg-icon svg-icon-2tx svg-icon-warning me-4" }
const _hoisted_15 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex flex-stack flex-grow-1\"><div class=\"fw-bold\"><h4 class=\"text-gray-800 fw-bolder\">We need your attention!</h4><div class=\"fs-6 text-gray-600\"> Your payment was declined. To start using tools, please <a class=\"fw-bolder\" href=\"#\">Add Payment Method</a>. </div></div></div>", 1)
const _hoisted_16 = {
  key: 1,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "card-header border-0 pt-5" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-start flex-column" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "card-label fw-bolder fs-4" }, "Firma Bilgileri"),
    /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-bold fs-8" }, " Entegrasyonlarınızdan otomatik alınan bilgiler ")
  ])
], -1)
const _hoisted_18 = { class: "card-body pt-3" }
const _hoisted_19 = { class: "row" }
const _hoisted_20 = {
  key: 0,
  class: "col-md-6 mb-5"
}
const _hoisted_21 = { class: "text-muted fs-8 fw-semibold text-uppercase" }
const _hoisted_22 = { class: "fw-bold fs-6 text-gray-900" }
const _hoisted_23 = { class: "row gy-10 gx-xl-10" }
const _hoisted_24 = { class: "col-xl-6" }
const _hoisted_25 = { class: "col-xl-6" }
const _hoisted_26 = {
  key: 2,
  class: "row gy-10 gx-xl-10"
}
const _hoisted_27 = { class: "col-xl-6" }
const _hoisted_28 = { class: "col-xl-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_KTListWidget5 = _resolveComponent("KTListWidget5")!
  const _component_KTTableWidget5 = _resolveComponent("KTTableWidget5")!
  const _component_KTChartWidget1 = _resolveComponent("KTChartWidget1")!
  const _component_KTListWidget1 = _resolveComponent("KTListWidget1")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    false
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createVNode(_component_router_link, {
              to: "/account/settings",
              class: "btn btn-primary align-self-center"
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("span", _hoisted_14, [
                _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen044.svg" })
              ]),
              _hoisted_15
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.hasAnyInfo)
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _hoisted_17,
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.infoRows, (row, i) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
                  (row.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, _toDisplayString(row.label), 1),
                        _createElementVNode("div", _hoisted_22, _toDisplayString(row.value), 1)
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128))
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_23, [
      _createElementVNode("div", _hoisted_24, [
        _createVNode(_component_KTListWidget5, {
          "widget-classes": "card-xxl-stretch mb-5 mb-xl-10",
          data: _ctx.Logs,
          hasMore: _ctx.hasMoreLogs,
          onNeedRefresh: _cache[0] || (_cache[0] = ($event: any) => (_ctx.refreshLogs())),
          onLoadMore: _cache[1] || (_cache[1] = ($event: any) => (_ctx.loadMoreLogs()))
        }, null, 8, ["data", "hasMore"])
      ]),
      _createElementVNode("div", _hoisted_25, [
        _createVNode(_component_KTTableWidget5, {
          "widget-classes": "card-xxl-stretch mb-5 mb-xl-10",
          data: _ctx.Integrations,
          onNeedRefresh: _cache[2] || (_cache[2] = ($event: any) => (_ctx.refreshData()))
        }, null, 8, ["data"])
      ])
    ]),
    false
      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            _createVNode(_component_KTChartWidget1, { "widget-classes": "card-xxl-stretch mb-5 mb-xl-10" })
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createVNode(_component_KTListWidget1, { "widget-classes": "card-xxl-stretch mb-5 mb-xl-10'" })
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}